<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs ref="tabs">
      <TabPane
        :label="profileLimit.cn || ''"
        style="padding-top:20px;min-height: 200px"
      >
        <Row type="flex" align="middle">
          <template v-for="(item, index) in profileLimit.field">
            <i-col
              :key="index"
              span="6"
              style="padding-left:50px;padding-top:10px;padding-bottom:10px;"
            >
              {{ item.cn }}{{ item.unit ? `(${item.unit})` : "" }}
            </i-col>
            <i-col :key="index + 0.5" span="6">
              <InputNumber
                v-model="profileOut[item.name]"
                @on-change="changeValue"
                :max="m_max(item.max)"
                :min="m_min(item.min)"
                style="width:90%"
                v-if="item.type === 'number'"
              />
              <Select
                v-model="profileOut[item.name]"
                @on-change="changeValue"
                transfer
                style="width:90%"
                v-if="item.type === 'enum'"
              >
                <Option
                  v-for="(sub, index) in item.enum"
                  :value="index"
                  :key="index"
                >
                  {{ sub.cn }}
                </Option>
              </Select>
            </i-col>
          </template>
        </Row>
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
import Template from "../../components/template.vue";
export default {
  props: {
    instruction: {},
    callback: {
      type: Function,
    },
  },
  computed: {},
  mounted() {
    let _this = this;
    console.log(_this.instruction);
    let m_profileLimit = global.profileTest[_this.instruction.selectOption];
    _this.profileLimit = m_profileLimit;
    _this.profileOut = {};
    m_profileLimit.field.forEach((m_element) => {
      _this.profileOut[m_element.name] = m_element.default || 0;
    });
    this.callback(this.profileOut);
  },
  components: {},
  data() {
    Template;
    return {
      profileLimit: {},
      profileOut: {},
      isSpinShow: false,
    };
  },
  methods: {
    changeValue() {
      this.callback(this.profileOut);
    },
    m_min(inObj) {
      if (inObj === undefined || inObj === null || inObj === "") {
        return -Infinity;
      }
      return inObj;
    },
    m_max(inObj) {
      if (inObj === undefined || inObj === null || inObj === "") {
        return Infinity;
      }
      return inObj;
    },
  },
};
</script>
<style>
.table table {
  table-layout: auto;
  width: 100% !important;
}
</style>
